import NotesTable from "./NotesTable";

const QualityIssuesTable = (props) => (
  <NotesTable
    {...props}
    itemsKey="quality_issues"
    title="Quality Issues"
    columnTitle="Issue"
    addButtonLabel="Add a Quality Issue"
  />
);

export default QualityIssuesTable;
